export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-950 text-secondary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-base text-white"></i>
              </span>
              <span className="font-heading text-lg text-secondary-50">香蕉影视</span>
            </div>
            <p className="text-secondary-400 text-xs leading-relaxed">
              香蕉影视是领先的免费高清在线追剧平台，提供最新热播电视剧大全观看服务，
              支持1080P超清画质、秒开不缓冲、全集免费看，
              是追剧爱好者的必备之选。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-secondary-100 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#ranking" className="block text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">热播排行榜</a>
              <a href="#updates" className="block text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">追剧快讯</a>
              <a href="#media" className="block text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">精彩剧集</a>
              <a href="#faq" className="block text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-secondary-100 mb-4">内容分类</h4>
            <div className="space-y-2">
              <a href="#cards" className="block text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">国产剧</a>
              <a href="#cards" className="block text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">韩剧</a>
              <a href="#cards" className="block text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">美剧</a>
              <a href="#cards" className="block text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">日剧</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-secondary-100 mb-4">合作伙伴</h4>
            <p className="text-xs text-secondary-500 leading-relaxed">更多优质合作伙伴即将入驻，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-secondary-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; 2024 香蕉影视 bananatv.com 版权所有 | 仅供学习交流，请支持正版
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors cursor-pointer">联系我们</a>
            <a href="#faq" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors cursor-pointer">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}